import React from "react";

interface SliderProps {
  min: number;
  max: number;
  step?: number;
  value?: number;
  onChange?: (value: number) => void;
}

export default function Slider({
  min,
  max,
  step = 1,
  value,
  onChange
}: SliderProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(Number(e.target.value));
  };

  const pct = value !== undefined && max > min
    ? ((value - min) / (max - min)) * 100
    : 0;

  return (
    <div className="w-full">
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        className="w-full h-2 rounded-lg appearance-none cursor-pointer"
        style={{
          background: `linear-gradient(to right, var(--color-primary, #1670E7) ${pct}%, #e2e8f0 ${pct}%)`,
          accentColor: "var(--color-primary, #1670E7)"
        }}
      />
      <div className="flex justify-between text-xs text-slate-400 mt-1">
        <span>{min}</span>
        <span>{max}</span>
      </div>
    </div>
  );
}
